import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const fetchLineDetails = (query) => {
  const { QuoteId, LineNumber } = query;

  return fetchGet(`CustomerQuoteEnquiry/Quote/${QuoteId}/Line/${LineNumber}/ComponentDetails`)
    .then((something) => {

      return something ? objectify(something.QuoteLineComponent) : null;
    });
};

export const fetchLineDetailSummary = (query) => {
  const { QuoteId, LineNumber } = query;

  return fetchGet(`CustomerQuoteEnquiry/Quote/${QuoteId}/Line/${LineNumber}/ComponentSummary`, {}, 'Inline')
    .then((something) => {
      return something ? objectify(something.QuoteLineComponent) : null;
    });
};

export const fetchReservationDetails = (query) => {
  const { QuoteId, LineNumber } = query;

  return fetchGet(`CustomerQuoteEnquiry/Quote/${QuoteId}/Line/${LineNumber}/ComponentReservations/Details`, {}, 'Inline')
    .then((something) => {
      return something ? objectify(something.ReservationDetail) : null;
    });
};

export const fetch = async (query: { QuoteId: number; LineNumber: number; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { QuoteId, LineNumber, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `CustomerQuoteEnquiry/Quote/${QuoteId}/Line/${LineNumber}/BillofMaterials`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        QuoteLineBOM: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.QuoteLineBOM) {

            return {
              records: result.QuoteLineBOM.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
